import clsx from 'clsx';
import { useMemo } from 'react';

import * as styles from './CardContainer.module.css';

import type { CSSProperty, InlineStyleWithVariable, InsifyProps, ShadowType } from '../../../../types';

const shadowTypeToVariable = {
  hard: 'var(--shadow-hard)',
  soft: 'var(--shadow-soft)',
  none: 'none',
};

const knownBackgrounds: Record<string, string> = {
  lightGreyGradient: 'linear-gradient(180.35deg, #FFFFFF -93.55%, #F8F5FE 99.7%)',
  green: '#04c982',
};

type Props = InsifyProps & {
  className?: string;
  style?: InlineStyleWithVariable;
  background?: CSSProperty.Background | keyof typeof knownBackgrounds;
  shadowType?: ShadowType;
};

export const CardContainer = ({
  className,
  style,
  background = 'white',
  shadowType = 'none',
  children,
}: React.PropsWithChildren<Props>) => {
  const inlineStyle = useMemo(() => {
    let styleObject: InlineStyleWithVariable = undefined;

    if (background !== undefined) {
      if (typeof background === 'string' && background in knownBackgrounds) {
        styleObject = { ...(styleObject ?? {}), '--card-background': knownBackgrounds[background] };
      } else {
        styleObject = { ...(styleObject ?? {}), '--card-background': background };
      }
    }

    styleObject = { ...styleObject, '--card-shadow': shadowTypeToVariable[shadowType] };

    return { ...styleObject, ...style };
  }, [background, shadowType]);

  return (
    <div className={clsx(styles.CardContainer, className)} style={inlineStyle}>
      {children}
    </div>
  );
};
